import axios from 'axios'
const server = process.env.VUE_APP_API_URL || ''
const api = `${server}/api/customer/artist`

const loadArtists = () => {
  return axios.get(api, {})
}

export default {
  loadArtists
}
